<div cdkDropList
     #componentsList="cdkDropList"
     [cdkDropListData]="componentsGroup.components"
     class="d-flex flex-row w-100 align-items-start flex-wrap"
     (cdkDropListDropped)="dropComponent($event)"
     [cdkDropListDisabled]="componentsGroup.components.length <= 1">
  <div class="w-100" *ngIf="componentsGroup.components.length >= 2">
    <div class="cdc-label" *ngIf="componentsGroup.title">
      <span class="text-new-lines" *ngIf="componentsGroup.title">
        {{ componentsGroup.title }}
      </span>
      <mat-icon class="component-title-help" *ngIf="componentsGroup.helpText && componentsGroup.helpText.length > 0" matTooltipClass="multiline-tooltip" matTooltip="{{componentsGroup.helpText}}" [matTooltipPosition]="'right'">help</mat-icon>
    </div>

    <div *ngIf="componentsGroup.description" class="cdc-label-description text-new-lines">
      {{ componentsGroup.description }}
    </div>
  </div>
  <div *ngFor="let component of componentsGroup.components;"
       [ngClass]="getComponentSize(component)"
       cdkDrag
       class="p-1 d-flex flex-column"
       #componentElement>

    <div class="componentUnselected"
         [ngClass]="{
          'componentSelected': selectedComponentId === component.id && hoveredComponentId !== component.id,
         'border-dashed': hoveredComponentId === component.id
         }"
         (click)="onSelectComponent($event, component.id, componentsGroup.id)">

      <div class="flex-row justify-content-between componentHeader">
        <div class="d-flex flex-row">
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'answers')" matTooltip="{{'Multiple answers' | translate}}" *ngIf="component.config?.multipleAnswers === true && component.type !== ComponentType.SELECT" [ngClass]="{'iconVisible': selectedComponentId === component.id}">view_list</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'roles')" matTooltip="{{'Roles' | translate}}" *ngIf="hasRoles(component)" [ngClass]="{'iconVisible': selectedComponentId === component.id}">accessibility</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'conditions')" matTooltip="{{'Conditions' | translate}}" *ngIf="hasConditions(component)" [ngClass]="{'iconVisible': selectedComponentId === component.id}">settings_input_composite</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'connections')" matTooltip="{{'IN' | translate}} {{'Connections' | translate}}" *ngIf="hasConnections(component, Direction.IN)" [ngClass]="{'iconVisible': selectedComponentId === component.id}">open_in_browser</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'connections')" matTooltip="{{'OUT' | translate}} {{'Connections' | translate}}" *ngIf="hasConnections(component, Direction.OUT)" [ngClass]="{'iconVisible': selectedComponentId === component.id}">open_in_new</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'connections')" matTooltip="CDC {{'Connections' | translate}}" *ngIf="hasConnections(component, Direction.IN_OUT)" [ngClass]="{'iconVisible': selectedComponentId === component.id}">alternate_email</mat-icon>
          <mat-icon class="icon" (click)="onSelectComponent($event, component.id, componentsGroup.id, 'keyindicator')" matTooltip="{{'Key indicator weight' | translate}}" *ngIf="component.keyIndicator?.weight != undefined && component.keyIndicator?.weight! > 0" [ngClass]="{'iconVisible': selectedComponentId === component.id}">scale</mat-icon>
        </div>

        <div>
          <mat-icon class="icon-g drag-icon"
                    [ngClass]="{'iconVisible': selectedComponentId === component.id}"
                    cdkDragHandle
                    matTooltip="{{'Drag' | translate}}"
                    *ngIf="componentsGroup.components.length > 1">
            drag_indicator
          </mat-icon>

        </div>
      </div>

      <app-component-config [component]="component"
                            [haveIndexTitles]="componentsGroup.multipleConfig?.haveIndexTitles === true && componentsGroup.components[0]!.id === component.id"
                            (hoverStart)="onHoverStart($event)"
                            (hoverEnd)="onHoverEnd($event)"></app-component-config>
    </div>

  </div>
</div>
